import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllRoles, searchRoles } from '../../redux/slice/roles/roleSlice';
import CreateRole from '../modals/roles/CreateRole';
import RolesTable from './RolesTable'

const Roles = () => {
    const [hasAddRole, setHasAddRole] = useState()
    const [pageNumber, setPageNumber] = useState(1);
    const [filterBy, setFilterBy] = useState()

    const { all_roles, isUpdated, isActivated, createSuccess } = useSelector((state) => state?.role );
    const { user_permissions } = useSelector((state) => state?.auth?.user);
    
    const dispatch = useDispatch();

    // fetch roles on click of pagination links
  const fetchRolesHandler = async (pageNum) => {
    setPageNumber(pageNum);
    dispatch(fetchAllRoles(pageNum));
  };

  useEffect(() => {
    if (!filterBy) {
        dispatch(fetchAllRoles({pageNumber}));   
    }

    if (isUpdated || isActivated ) {
        dispatch(fetchAllRoles({pageNumber})); 
    }

  }, [dispatch, pageNumber, isUpdated, isActivated, filterBy]);

  useEffect(() => {
    if (createSuccess ) {
        dispatch(fetchAllRoles({pageNumber})); 
    }

  }, [dispatch, pageNumber, createSuccess]);

    useEffect(() => {
        setHasAddRole(user_permissions?.some(permission => permission.name === 'create role'))
    }, [user_permissions])

    const handleSearch = (e) => {
        e.preventDefault();
        if (filterBy.length) {
          dispatch(searchRoles(filterBy))
        }
    } 
  

  return (
    <div className='position-relative'>
        <div className={`d-flex ${hasAddRole ? 'justify-content-between' : 'justify-content-end'}`}>
            {hasAddRole && <div
                className='d-flex gap-2 justify-content-center align-items-center rounded-1 btn-primary cursor-p'
                style={{ height: "30px", padding: "10px 10px" }}
            >
                <span>
                    <i className='mdi mdi-plus fs-4'></i>
                </span>
                <span 
                    className='text-dark pe-2 text-white'
                    data-bs-toggle='modal'
                    data-bs-target='#createRole'
                >
                    Create Role
                </span>
                <CreateRole modal_id='createRole'/>
            </div>}
            <form
                onSubmit={handleSearch}
                className='d-flex bg-primary-1 align-items-center '
                style={{ height: "30px", width: "217px" }}
            >
                <input
                    type='search'
                    value={filterBy}
                    className='border-0'
                    placeholder='Search...'
                    onChange={(e) => setFilterBy(e.target.value)}
                    style={{ height: "28px", marginLeft: "1px", outline: "none" }}
                />
                <button
                    type='submit'
                    className='btn btn-primary btn-sm d-flex align-items-center gap-1'
                    style={{ height: "28px" }}
                >
                <i className='uil uil-search text-white fs-4'></i>
                </button>
            </form>
        </div>
        <RolesTable roles={all_roles} fetchRolesHandler={fetchRolesHandler} />
    </div>
  )
}

export default Roles